import React from 'react'
import styled from 'styled-components'
import { ProgressBar } from 'react-bootstrap';

const Skillitem=styled.div`
margin-bottom: 20px;
`;
export default function Skill() {
    return (
        <Skillitem>
            <h5> HTML</h5>
            <ProgressBar now={12} label={"60"} />
        </Skillitem>
    )
}
